import styled from '@emotion/styled';

import ArrowDownIcon from './ArrowDownIcon';
import ArrowUpIcon from './ArrowUpIcon';

function InquiryNavigator() {
    const handleScroll = (direction: 'top' | 'bottom') => {
        const contents = document.querySelector<HTMLDivElement>('#cta-contents')!;
        if (direction === 'top') {
            contents.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            const { scrollHeight } = contents;
            contents.scrollTo({ top: scrollHeight, behavior: 'smooth' });
        }
    };
    return (
        <Container>
            <ArrowUpIcon onClick={() => handleScroll('top')} />
            <ArrowDownIcon onClick={() => handleScroll('bottom')} />
        </Container>
    );
}

const Container = styled.div`
    align-items: center;
    background-color: var(--color-gray1);
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.14);
    display: flex;
    flex-direction: column;
    height: 85px;
    justify-content: space-between;
    min-height: 85px;
    min-width: 40px;
    padding: 6px 0;
    width: 40px;
    position: fixed;
    right: 20px;
    bottom: calc(var(--safe-area-bottom) + 114px);
`;

export default InquiryNavigator;
